export default "__VITE_ASSET__B1hEjr9y__"